export default {
    methods: {
        px2rem(px = 0) {
            return `${(px / 375) * 18.75}rem`
        }
    }
}